<template>
  <v-container fluid class="mt-10">
    <div class="d-flex justify-center align-center" style="background: white; padding: 20px; border: 1px solid red">
      <div class="box" :style="boxStyle">
        <div class="up" :style="upperStyle"></div>
        <div class="down" :style="downStyle">öV-Pad</div>
      </div>
    </div>
  </v-container>
</template>

<script>
import logo from '@/components/logo/LogoGenerated';
import common from '@/mixins/common';

export default {
  name: 'colors',
  mixins: [common],
  components: {},
  created: function () {
    //console.debug('colors', this.$vuetify.theme.themes);
  },
  data: () => ({
    themes: ['light', 'dark'],
    colorToChange: '',
    color: {},
    customer: 'customer',
    functionColors: ['background', 'primary', 'secondary', 'accent', 'error', 'info', 'success', 'warning'],
    drawer: false,
    group: null,
  }),
  computed: {
    currentTheme() {
      return this.darkMode ? 'dark' : 'light';
    },
    boxStyle() {
      return { background: 'white' };
    },
  },
  watch: {
    color: function (v) {
      //console.debug('color changed', v);
      if (this.colorToChange) {
        this.$vuetify.theme.themes[this.themeName][this.colorToChange] = v.hex;
      }
    },
    group() {
      this.drawer = false;
    },
  },
};
</script>
<style scoped>
.box {
  width: 512px;
  height: 512px;
  border-radius: 40px;
  border: 1px solid #f0f0f0;
}
</style>
